import types from 'actions/types'
import Immutable from 'seamless-immutable'
import reduceReducers from 'reduce-reducers'
import merge from 'lodash/merge'
import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import auth from './auth'
import data from './data'
import search from './search'
import snackbar from './snackbar'
import contactsContext from './contactsContext'
import customerContext from './customerContext'
import deliveriesContext from './deliveriesContext'
import dirty from './dirty'
import dialogs from './dialogs'
import notifications from './notifications'
import quotingContext from './quotingContext'
import priceListsContext from './priceListsContext'
import productionContext from './productionContext'
import purchasingContext from './purchasingContext'
import salesContext from './salesContext'
import settingsContext from './settingsContext'
import settings from './settings'
import diaryContext from './diaryContext'
import integration from './integration'
import invoicingContext from './invoicingContext'
import ui from './ui'
import onboarding from './onboarding'
import routes from './routes'
import subscriptions from './subscriptions'
import language from 'reducers/language'
import departmentContext from "reducers/departmentContext"
import pricingCalculator from './pricingCalculator'

const currentContext = (state = Immutable('contacts'), action) => {
  switch (action.type) {
    case types.SYNC_WITH_ROUTE: return action.context
    default: return state
  }
}

const coreDataReducer = combineReducers({
  auth,
  contactsContext,
  currentContext,
  customerContext,
  data,
  deliveriesContext,
  departmentContext,
  dialogs,
  diaryContext,
  dirty,
  integration,
  invoicingContext,
  language,
  notifications,
  onboarding,
  priceListsContext,
  pricingCalculator,
  productionContext,
  purchasingContext,
  quotingContext,
  routes,
  routing,
  salesContext,
  search,
  settings,
  settingsContext,
  snackbar,
  subscriptions,
  ui,
})

const globalReducer = (state, action) => {
  switch (action.type) {
    case types.LOGOUT_ATTEMPT :
      // Note below, for these general actions we need to supply what aspects of
      // the state we want in to the core reducer. in most of these
      // global changes we only want to return the routing
      const { routing } = state
      return coreDataReducer({ routing, auth: { sessionChecked: true } }, action)

    case types.STATE_LOAD_SUCCESS:
    case types.CONFIG_LOAD_SUCCESS:
      const newState = merge(state, action.data)
      return coreDataReducer(newState, action)
    default: return state
  }
}

export default reduceReducers(globalReducer, coreDataReducer)
